export class MarcheDocument {
  constructor(
    public uuid: string | null,
    public dateDebut: Date | null,
    public dateFin: Date | null,
    public numero: string,
    public documentUuid: string | null,
    public nom?: string
  ) {}

  static adapt(item: any): MarcheDocument {
    return new MarcheDocument(
      item.uuid ?? null,
      item.dateDebut ? item.dateDebut : null,
      item.dateFin ? item.dateFin : null,
      item.numero ?? '',
      item.documentUuid ?? null,
      item.nom ?? null
    );
  }
}
